import { render, staticRenderFns } from "./TheSiteFooter.vue?vue&type=template&id=5111a22e&"
import script from "./TheSiteFooter.vue?vue&type=script&lang=js&"
export * from "./TheSiteFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports